import { useMemo } from 'react';

/**
 * Returns an object mapping filter keywords to their corresponding filter id
 * @returns
 */
export const useFilterKeywordToFilterId: () => {
	[k: string]: 'contributor';
} = () => {
	return useMemo(() => {
		return {};
	}, []);
};
